import { useQuery } from '@tanstack/react-query';

import type { ApiError } from '@/shared/api/errors';

import { activationApi, activationKeys } from './api';
import type { TriageActivation } from './types';

/**
 * The activation matrix of the API that answers.
 *
 * It comes from that process's environment and only changes on a redeploy, so a minute of
 * `staleTime` is generous rather than risky: the value cannot move while the page is open.
 * Not retried on 403: a non-admin will get the same 403 three times.
 */
export function useActivation() {
  return useQuery<TriageActivation, ApiError>({
    queryKey: activationKeys.activation,
    queryFn: activationApi.activation,
    staleTime: 60_000,
    retry: (failureCount, error) => error.status !== 403 && failureCount < 2,
  });
}
